<template>
  <div class="model-container">
    <BouncingModal v-for="modal in modals" :key="modal.id" :speed="modal.speed" :initial-angle="modal.angle"
      :hover-pause="false" @close="removeModal(modal.id)"
      :style="{ backgroundColor: modal.bgColor, color: modal.color, borderColor: modal.borderColor }">
      <div class="modal-content" v-html="modal.content">
      </div>
    </BouncingModal>
  </div>
  <div class="bv627">
    <div class="bgx">
      <img class="hero-img" src="https://vcos.vds.pub/vds-pub-fonts/assets-627/BV627.png">
      <p class="welcome-title" style="margin-top: 0px;">真遗憾，被你发现了。</p>
      <p class="welcome-title" style="margin-top: 0px;">欢迎访问BV627全球唯一网站</p>

      <!-- 播放按钮 -->
      <button id="play-button">播放品牌声音</button>
      <button class="modal-button" @click="addModal">召唤弹窗</button>

      <p class="welcome-title" style="margin-top: 20px;">2026品牌视频</p>

      <!-- 默认静音 + loop -->
      <video style="height: 99%; width: 99%;" id="video" src="https://vcos.vds.pub/vds-pub-fonts/assets-627/BV627.mp4"
        autoplay muted loop></video>

      <!-- 视频控制按钮（取消静音/静音 & 暂停/播放） -->
      <div class="video-controls">
        <button id="mute-toggle">取消静音</button>

        <button id="pause-toggle">暂停</button>
      </div>

      <p>
        该视频有BV627视频断点云提供十分卡慢的播放支持！！！！！！我是小孩子我会用一点服务器写一点代码用上线了服务发布我就要死了命炫耀！！！！
      </p>
    </div>

    <section class="notice-zone">
      <div class="notice-panel">
        <div class="notice-head">
          <span class="notice-icon">🔊</span>
          <span class="notice-label">公告</span>
          <span class="notice-kicker">BV627特别播报</span>
        </div>
        <div class="notice-body">
          这里是BV627网站
        </div>
      </div>
    </section>

    <section class="chapter-splash" :style="chapterStyle(chapterSlots.hero)">
      <div class="chapter-shell">
        <h2 class="chapter-title">{{ chapterSlots.hero.title }}</h2>
      </div>
    </section>

    <h1 style="margin-left: 20px; margin-top: 10px; color: #fff000;">BV627今日视点</h1>

    <div class="scroll-container">
      <div class="card-container" id="card-container">
        <div class="card" style="background-image: url('https://vcos.vds.pub/vds-pub-fonts/assets-627/znn.png');"
          data-title="今日视点 today de viewpoiot" data-subtitle="我要带你看 BV627 在迷惑挑战吗？" data-align="center">
        </div>
        <!--
        <div class="card"
          style="background-image: url('https://puui.qpic.cn/vpic_cover/k3532ms7231/k3532ms7231_1694584608_hz.jpg/1280');"
          data-title="真的很“环保”" data-subtitle="Carrot说的对呀，直接拿现成的，为什么还要重新设计？简直是对能源的浪费！" data-align="top-left"
          data-badge="news">
        </div>
        <div class="card"
          style="background-image: url('https://vcos.vds.pub/vds-pub-fonts/assets-627/<placeholder>.jpg');"
          data-title="点歌：PENTIMENT（616警告（（（）" data-subtitle="PURE MEMORY GREAT GREAT 4 U，TRACK LOST BAD BAD 2 ME。" data-align="bottom-left" data-badge="event">
        </div> -->

        <div class="card"
          style="background-image: url('https://vcos.vds.pub/vds-pub-fonts/assets-627/340AD0C5F1D9D14D447E37F42373235A.jpg');"
          data-title="我要给祖上十八代申请直播间。" data-subtitle="精彩因我而优，欢乐随我而动。" data-align="bottom-left" data-badge="event"></div>
        <div class="card" style="background-image: url('https://vcos.vds.pub/vds-pub-fonts/assets-627/dot.jpg');"
          data-title="我患抑郁症了。" data-subtitle="为什么说什么话都要带句号。诶好奇怪。为什么我也开始带句号了。" data-align="bottom-left"
          data-badge="latest"></div>
        <div class="card" style="background-image: url('https://vcos.vds.pub/vds-pub-fonts/assets-627/ang.png');"
          data-title="请熟读BV627综合物种中心标配语言" data-subtitle="1.我得了“玉玉症”
            2.小（字母）蛋仔派对
            3.闹事的
            4.申请直播间，反复申请直播间，还有直播间
            5.被受害的人是有错的
            6.管不了事的我和我" data-align="bottom-left"></div>
        <!--
        <div class="card"
          style="background-image: url('https://vcos.vds.pub/vds-pub-fonts/image4.jpg');"
          data-title="标题4"
          data-subtitle="小标题4"
          data-align="bottom-left"
          data-badge="news"
        ></div>
        <div class="card"
          style="background-image: url('https://vcos.vds.pub/vds-pub-fonts/image5.jpg');"
          data-title="标题5"
          data-subtitle="小标题5"
          data-align="bottom-right"
        ></div>
        -->
      </div>
    </div>

    <div class="indicator-container" id="indicator-container">
    </div>

    <section class="chapter-splash" :style="chapterStyle(chapterSlots.cards)">
      <div class="chapter-shell">
        <p class="chapter-meta">自己长出来的一页</p>
        <h2 class="chapter-title">{{ chapterSlots.cards.title }}</h2>
      </div>
    </section>

    <!-- <h1 style="margin-left: 20px; margin-top: 10px; color: #fff000;">BV627开关机视频</h1> -->

    <section class="chapter-splash" :style="chapterStyle(chapterSlots.qa)">
      <div class="chapter-shell">
        <p class="chapter-meta">章节感很强对吧</p>
        <h2 class="chapter-title">{{ chapterSlots.qa.title }}</h2>
      </div>
    </section>

    <h1 style="margin-left: 20px; margin-top: 10px; color: #fff000;">在Q&amp;A Time可以（？）做的抽象事情</h1>
    <ul class="infos">
      <li>请大家继续团结在VDS627的放松过自媒体圈，嗤之以鼻的自媒体圈。这就是我给你提供VDSLS的原因</li>
      <li>精彩直播台 绽放新精彩 您现在正在收看的是V—D—S—1——直播频道 VDS1是KLCF小钟团黑金VIP成员 我和汪定芬是夫妻 嗲嗲夫妻嗲嗲爱 对立你带我走吧对立 ██616还我对立！！！！！</li>
      <li>最后就是A西八……最后就是A18 Pro的超强性能</li>
      <li>点歌：PENTIMENT（616警告（（（）</li>
      <li>Ask: 欢乐中国英特尔MOMO频道2024年改版包装</li>
      <li>随机复制一条别人的幸运提问并且只改几个字就再发</li>
      <li>我趣了我问了 但就是回答不上来的问题</li>
      <li>我——不——曾——忘——怀————（震声）</li>
      <li>\PARN/（《Q&amp;A Time》EP10配音的某段无法过审的素材）</li>
      <li>你知道VDS的八月频道吗？是不是在，8月58号</li>
      <li>本节目由儿童学习广播，this progr@ is procast i childr@k</li>
      <li>KohaD：请不要游玩《舞萌DX 2077》</li>
      <li>人体发声器.wav.tar.xz分子</li>
      <li>严禁拉黑或辱骂以及骚扰我本人，我xQc是好人！</li>
      <li>#直播频道改革运动# 建议“VDSlive24”网络直播频道调整为“VDS NEWS 24”并更改“VDS NEWS 24（原VDSlive24）”频道节目播出内容为24小时不间断网络热门新闻资讯短视频轮播</li>
      <li>童年新时光.wacca.wtf</li>
      <li>王炸！727连炸！拉嗨不谢！！！</li>
      <li>6月27号的几个意见建议都是对BV627的健康发展有益的！！！！！！！！！！</li>
      <li>随机拿走桃井爱莉/约尔/白教练（wt</li>
      <li>如果您喜欢这段视频的话，请来个“三连”“关注”以及“重大推荐”哦</li>
      <li>BV627电视电视开关机，开机。啊啊啊啊开机辣开机辣！！！关机，关机辣关机辣</li>
    </ul>
    <h1 style="margin-left: 20px; margin-top: 10px; color: #fff000;">
      啊啊啊啊啊呜呜呜呜呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊啊啊啊啊呜呜呜呜呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊啊啊啊啊呜呜呜呜呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊啊啊啊啊呜呜呜呜呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊啊啊啊啊呜呜呜呜呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊啊啊啊啊呜呜呜呜呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊啊啊啊啊呜呜呜呜呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊啊啊啊啊呜呜呜呜呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊啊啊啊啊呜呜呜呜呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜这里是某只179的留言板或者说备忘录或者blablablablablablablablablab
    </h1>
    <ul class="infos">

      <li>啊呜啊呜啊呜啊呜我是179啊啊啊啊啊呜呜呜呜呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜啊呜</li>
      <li>咳咳</li>
    </ul>

    <p style="margin: 10px; font-size: 13px; font-family: inherit; color: rgb(47, 47, 47);">
      *本页面的设计和动效仅代表页面设计者，与唯迪爱思官方立场无关。页面中所使用的“BV627”名称由BV627体系衍生而来，BV627是BV627工作室持有版权的标志，所有相关logo的设计均归该工作室所有。如有任何疑问或侵权问题需要解答，请联系我们或BV627。
    </p>

    <section class="chapter-splash chapter-splash-last" :style="chapterStyle(chapterSlots.outro)">
      <div class="chapter-shell">
        <p class="chapter-meta">最后一个没头没尾的章节</p>
        <h2 class="chapter-title">{{ chapterSlots.outro.title }}</h2>
      </div>
    </section>

    <div id="vc-footer"></div>

    <!-- 隐藏的音频播放器 -->
    <audio id="opening-audio" src="https://vcos.vds.pub/vds-pub-fonts/assets-627/opening.wav"
      style="display:none;"></audio>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import BouncingModal from './BouncingModal.vue';

const modals = ref([]);
let nextId = 1;

function shuffleArray(items) {
  const result = [...items];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

const chapterThemes = [
  {
    accent: '#fff000',
    glow: 'rgba(255, 240, 0, 0.32)',
    bg: 'linear-gradient(135deg, rgba(255, 240, 0, 0.22), rgba(255, 94, 0, 0.16))',
    tilt: '-1.5deg'
  },
  {
    accent: '#00ff90',
    glow: 'rgba(0, 255, 144, 0.28)',
    bg: 'linear-gradient(135deg, rgba(0, 255, 144, 0.2), rgba(0, 120, 255, 0.16))',
    tilt: '1.1deg'
  },
  {
    accent: '#ff66d9',
    glow: 'rgba(255, 102, 217, 0.32)',
    bg: 'linear-gradient(135deg, rgba(255, 102, 217, 0.22), rgba(111, 0, 255, 0.18))',
    tilt: '-0.8deg'
  },
  {
    accent: '#7cb7ff',
    glow: 'rgba(124, 183, 255, 0.28)',
    bg: 'linear-gradient(135deg, rgba(124, 183, 255, 0.22), rgba(255, 255, 255, 0.12))',
    tilt: '1.6deg'
  }
];

const chapterTitles = shuffleArray(['大', '失', '小', '大！！！']);
const chapterSlots = {
  hero: { title: chapterTitles[0], ...chapterThemes[0] },
  cards: { title: chapterTitles[1], ...chapterThemes[1] },
  qa: { title: chapterTitles[2], ...chapterThemes[2] },
  outro: { title: chapterTitles[3], ...chapterThemes[3] }
};

function chapterStyle(chapter) {
  return {
    '--chapter-accent': chapter.accent,
    '--chapter-glow': chapter.glow,
    '--chapter-bg': chapter.bg,
    '--chapter-tilt': chapter.tilt
  };
}

function randomColor() {
  const randomAlpha = () => {
    return `${Math.random() * 0xFF}`.split(".")[0]
  }
  return `rgb(${randomAlpha()}, ${randomAlpha()}, ${randomAlpha()})`
}

const contents = [
  '<h1 style="font-size: 2em">阿瑟复活节卡拉韦贵妃uijdgasyjdfghjb啊位于法国华51235=5023yd912y9i为库房黑雾回复uiah会i</h1>',
  '<h1 style="font-size: 2em">1347u56t12346785g234yhurb i2yugtyi</h1>',
]
console.log(randomColor())
// 添加弹窗
const addModal = () => {
  modals.value.push({
    id: nextId++,
    // 随机初始速度 2~5
    content: contents[(nextId - 1) % contents.length],
    speed: Math.floor(Math.random() * 9) + 2,
    color: randomColor(),
    bgColor: randomColor(),
    borderColor: randomColor(),
    // 随机初始角度 0~360
    angle: Math.floor(Math.random() * 360)
  });
  console.log((nextId - 1) % contents.length)
};

// 移除弹窗
const removeModal = (id) => {
  modals.value = modals.value.filter(m => m.id !== id);
};

onMounted(() => {
  addModal()
})

</script>

<script>

export default {
  name: "vc-bv627",
  mounted() {
    this.setCardHeight();
    this.initializeCards();

    const cardContainer = document.getElementById('card-container');
    const indicators = document.getElementById('indicator-container');
    const cards = cardContainer.querySelectorAll('.card');
    const audioPlayButton = document.getElementById('play-button');
    const audioOpening = document.getElementById('opening-audio');

    // 创建圆点指示器并添加点击事件
    cards.forEach((_, index) => {
      const indicator = document.createElement('div');
      indicator.classList.add('indicator');
      if (index === 0) indicator.classList.add('active');
      indicators.appendChild(indicator);

      // 点击圆点时滚动到对应的卡片
      indicator.addEventListener('click', () => {
        const cardWidth = cards[0].offsetWidth + 20; // 包含gap的宽度
        cardContainer.scrollTo({
          left: index * cardWidth,
          behavior: 'smooth' // 平滑滚动
        });
      });
    });

    const updateIndicators = () => {
      const scrollLeft = cardContainer.scrollLeft;
      const cardWidth = cards[0].offsetWidth + 20; // 包含gap的宽度
      const currentIndex = Math.round(scrollLeft / cardWidth);
      indicators.querySelectorAll('.indicator').forEach((indicator, index) => {
        indicator.classList.toggle('active', index === currentIndex);
      });
    };

    // 播放品牌声音
    audioPlayButton.addEventListener('click', () => {
      audioOpening.play();
    });

    // 监听卡片容器的滚动事件
    cardContainer.addEventListener('scroll', updateIndicators);

    // 监听窗口大小改变事件，重新计算视口高度
    window.addEventListener('resize', this.setCardHeight);

    // === 新增：视频控制按钮逻辑 ===
    const video = document.getElementById('video');
    const muteToggle = document.getElementById('mute-toggle');
    const pauseToggle = document.getElementById('pause-toggle');

    // 切换静音状态
    muteToggle.addEventListener('click', () => {
      video.muted = !video.muted;
      muteToggle.textContent = video.muted ? '取消静音' : '静音';
    });

    // 切换播放状态
    pauseToggle.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        pauseToggle.textContent = '暂停';
      } else {
        video.pause();
        pauseToggle.textContent = '播放';
      }
    });
    // === 新增结束 ===
  },
  methods: {
    setFavicon(url) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = url;
    },
    setCardHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      const cards = document.querySelectorAll('.card');
      cards.forEach(card => {
        card.style.height = `calc(var(--vh, 1vh) * 80)`; // 动态计算 80vh
      });
    },
    initializeCards() {
      const cards = document.querySelectorAll('.card');
      cards.forEach(card => {
        const title = card.getAttribute('data-title');
        const subtitle = card.getAttribute('data-subtitle');
        const align = card.getAttribute('data-align');
        const badge = card.getAttribute('data-badge');

        const content = document.createElement('div');
        content.classList.add('card-content', align);

        if (badge) {
          const badgeElem = document.createElement('div');
          badgeElem.classList.add('badge', `badge-${badge}`);
          switch (badge) {
            case 'latest':
              badgeElem.textContent = '最新发布';
              break;
            case 'news':
              badgeElem.textContent = '新闻';
              break;
            case 'event':
              badgeElem.textContent = '特别活动';
              break;
          }
          content.appendChild(badgeElem);
        }

        const titleElem = document.createElement('div');
        titleElem.classList.add('title');
        titleElem.textContent = title;

        const subtitleElem = document.createElement('div');
        subtitleElem.classList.add('subtitle');
        subtitleElem.textContent = subtitle;

        content.appendChild(titleElem);
        content.appendChild(subtitleElem);
        card.appendChild(content);
      });
    }
  }
};
</script>

<style scoped>
.bv627 {
  font-family: 'Comic Sans', 'Smiley Sans', Arial, sans-serif;
}

@font-face {
  font-family: 'Comic Sans';
  src: url("./fonts/LDFComicSans.ttf") format('truetype');
}

@font-face {
  font-family: 'Smiley Sans';
  src: url("./fonts/SmileySans-Oblique.ttf") format('truetype');
}

@keyframes rt {
  0% {
    transform: rotateZ(0deg) scale(0) rotateX(0);
    /* transform: rotateY(0deg); */
    /* transform: scaleY(0); */
  }

  30% {
    transform: rotateY(360deg) scale(1) rotateX(360deg) scaleX(5);
  }

  100% {
    /* transform: rotateZ(360deg); */
    filter: contrast(100%);
    filter: hue-rotate(1800deg);
    transform: rotateY(360deg) scale(1) rotateX(360deg);
    /* transform: scaleY(1); */
  }
}


.infos li:hover {
  /* transform: scaleX(3); */
  font-size: 3em;
  transform-origin: left;
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  color: #F85;
  filter: hue-rotate(720deg);
  animation: easeOutBounce 1s;
}

.bv627 {
  animation: rt 4s;
  font-family: 'Comic Sans', 'Smiley Sans', Arial, sans-serif;
  position: relative;
}

.scroll-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  /* 隐藏水平滚动条 */
}

.model-container {
  pointer-events: none;
  position: fixed;
  width: 100vw;
  height: calc(100svh - 50px);
  z-index: 1000;
}

.modal-button {
  padding: 20px;
  border: 2px solid black;
  background-color: #fff000;
  margin: 10px;
}

.welcome-titles {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.welcome-title {
  font-size: 60px;
  /* 加大标题字号 */
  padding: 0;
  /* 移除 padding */
  position: relative;
  animation: glitch 1s infinite;
  color: #00ff00;
}

.card-container {
  display: flex;
  gap: 20px;
  /* 卡片之间的间距 */
  overflow-x: auto;
  /* 横向滚动 */
  padding: 0 10vw;
  /* 安全区 */
  box-sizing: border-box;
  width: 100%;
  scroll-snap-type: x mandatory;
  /* 使滚动有吸附效果 */
}

.card-container::-webkit-scrollbar {
  display: none;
  /* 隐藏滚动条 */
}

.card {
  width: calc(100vw - 10vw);
  /* 卡片宽度为设备屏幕宽度减去安全区 */
  height: 80vh;
  /* 初始高度设置为80vh，会被JavaScript覆盖 */
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  /* 圆角 */
  flex: 0 0 auto;
  /* 保持卡片宽度不变 */
  scroll-snap-align: center;
  /* 滚动对齐 */
  position: relative;
  /* 相对定位以包含内部绝对定位元素 */
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.bgx {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.hero-img {
  height: 50px;
  margin-top: 80px;
}

.notice-zone {
  padding: 28px 18px 8px;
}

.notice-panel {
  width: min(1000px, calc(100vw - 32px));
  margin: 0 auto;
  padding: 14px;
  border: 4px solid #201100;
  border-radius: 28px;
  background:
    linear-gradient(135deg, rgba(255, 241, 0, 0.18), rgba(255, 94, 0, 0.22)),
    #1a130a;
  box-shadow:
    0 0 0 5px rgba(255, 242, 0, 0.12),
    0 18px 45px rgba(0, 0, 0, 0.45);
  transform: rotate(-0.8deg);
}

.notice-panel:hover {
  transform: rotate(0.8deg) scale(1.01);
  filter: hue-rotate(25deg) saturate(1.2);
  transition: transform 0.25s ease, filter 0.25s ease;
}

.notice-head,
.notice-body {
  border-radius: 20px;
  background: rgba(31, 33, 38, 0.92);
  border: 2px solid rgba(255, 255, 255, 0.08);
}

.notice-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 26px;
  color: #f6f1e8;
}

.notice-icon {
  font-size: 34px;
  line-height: 1;
  filter: drop-shadow(0 0 12px rgba(95, 157, 255, 0.75));
}

.notice-label {
  font-size: clamp(32px, 5vw, 52px);
  font-weight: 700;
  letter-spacing: 4px;
  text-shadow: 0 0 16px rgba(255, 255, 255, 0.2);
}

.notice-kicker {
  margin-left: auto;
  padding: 8px 12px;
  border: 2px dashed #fff000;
  border-radius: 999px;
  color: #fff000;
  font-size: 13px;
  white-space: nowrap;
  transform: rotate(3deg);
}

.notice-body {
  margin-top: 12px;
  padding: 26px;
  border-top: 3px solid rgba(255, 255, 255, 0.12);
  color: #f6f1e8;
  font-size: clamp(30px, 4vw, 44px);
  line-height: 1.2;
  text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.4);
}

.chapter-splash {
  padding: 28px 18px 16px;
  text-align: center;
}

.chapter-shell {
  width: min(820px, calc(100vw - 48px));
  margin: 0 auto;
  padding: 30px 24px;
  border: 4px double var(--chapter-accent);
  border-radius: 32px;
  background:
    var(--chapter-bg),
    rgba(20, 20, 20, 0.84);
  box-shadow:
    0 0 0 6px rgba(255, 255, 255, 0.05),
    0 0 30px var(--chapter-glow);
  transform: rotate(var(--chapter-tilt));
}

.chapter-shell:hover {
  transform: rotate(calc(var(--chapter-tilt) * -1)) scale(1.015);
  filter: hue-rotate(18deg);
  transition: transform 0.2s ease, filter 0.2s ease;
}

.chapter-meta {
  margin: 0 0 10px;
  color: var(--chapter-accent);
  font-size: 14px;
  letter-spacing: 6px;
  text-transform: uppercase;
}

.chapter-title {
  margin: 0;
  color: #ffffff;
  font-size: clamp(56px, 14vw, 140px);
  line-height: 0.95;
  text-shadow:
    0 0 16px var(--chapter-glow),
    4px 4px 0 rgba(0, 0, 0, 0.45);
}

.chapter-splash-last {
  padding-bottom: 32px;
}

/* 卡片文本与徽章 */
:deep(.card-content) {
  position: absolute;
  color: white;
}

:deep(.title) {
  font-family: var(--site-font-stack);
  font-size: 60px;
  /* 加大标题字号 */
  font-weight: 700;
}

:deep(.subtitle) {
  font-family: var(--site-font-stack);
  font-size: 20px;
}

:deep(.badge) {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
}

:deep(.badge-latest) {
  background-color: yellow;
  color: black;
}

:deep(.badge-news) {
  background-color: green;
  color: white;
}

:deep(.badge-event) {
  background-color: purple;
  color: white;
}

/* 对齐方式 */
:deep(.center) {
  justify-content: center;
  align-items: center;
}

:deep(.top-left) {
  top: 10px;
  left: 10px;
  text-align: left;
}

:deep(.top-right) {
  top: 10px;
  right: 10px;
  text-align: right;
}

:deep(.bottom-left) {
  bottom: 10px;
  left: 10px;
  text-align: left;
}

:deep(.bottom-right) {
  bottom: 10px;
  right: 10px;
  text-align: right;
}

.indicator-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 100px;
}

:deep(.indicator) {
  width: 10px;
  height: 10px;
  background-color: grey;
  border-radius: 50%;
  margin: 0 5px;
  transition: background-color 0.3s ease;
  cursor: pointer;
  /* 点击手型光标 */
}

:deep(.indicator.active) {
  background-color: white;
}

@media (max-width: 767px) {
  .notice-head {
    flex-wrap: wrap;
    padding: 18px 18px 16px;
  }

  .notice-kicker {
    margin-left: 0;
  }

  .notice-body {
    padding: 20px 18px;
  }

  .chapter-shell {
    padding: 22px 16px;
  }

  .chapter-meta {
    letter-spacing: 4px;
    font-size: 12px;
  }

  :deep(.title) {
    font-size: 45px;
  }

  :deep(.subtitle) {
    font-size: 15px;
  }
}

/* 播放按钮样式 */
#play-button {
  font-size: 20px;
  background-color: #fff000;
  color: rgb(0, 255, 0);
  border: none;
  width: 200px;
  height: 70px;
  border-radius: 5px;
  cursor: pointer;
}

/* 新增：视频控制按钮样式 */
.video-controls {
  margin-top: 10px;
}

.video-controls button {
  font-size: 16px;
  margin-right: 10px;
  background-color: #ffffc0;
  color: #000;
  border: 1px solid #777;
  width: 110px;
  height: 40px;
  border-radius: 5px;
  cursor: pointer;
}
</style>
